/**
 *
 * DecreaseBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import ArrowSecondaryBottomLeftIcon from '../../../../assets/v2/ArrowSecondaryBottomLeftIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.red};
    background: ${COLORS.redLight};
    border-color: ${COLORS.red};
    border-width: 0.5px;
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.red};
    }
  }
`;

function DecreaseBadge(props) {
  return <StyledBadge endIcon={<ArrowSecondaryBottomLeftIcon />} {...props} />;
}

export default memo(DecreaseBadge);
